import styled from 'styled-components';
import { shade } from 'polished';
import { Colors } from '../../../styles/constants';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 0 15px 15px;
`;

export const CertificadoInput = styled.div`
  text-align: center;
  display: flex;
  label {
    width: 100px;
    height: 48px;
    background: #fff;
    color: ${Colors.primary};
    right: 3px;
    bottom: 0;
    margin-bottom: 0;
    border: 1px solid ${Colors.primary};
    border-radius: 4px;
    transition: background-color 0.2s svg {
      width: 20px;
      height: 20px;
    }
    cursor: pointer;
    input {
      display: none;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: ${Colors.primary};
      color: #fff;
    }
  }
  div {
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
`;

export const Load = styled.div`
  position: absolute;
  z-index: 1000;
  background-color: #fff;
  height: 45px;
  width: 150px;
  border-radius: 10px;
  border: 1px solid #cecece;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 14px;
    animation: fa-spin 2s infinite linear;
    @keyframes fa-spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(359deg);
      }
    }
  }
`;

export const ContainerDados = styled.div`
  background-color: #fff;
  padding: 6px;
  border: 1px solid #d7d7d7;
  font-size: 0.8rem;
`;
